// In-memory tab context. Account/session authority always remains on the server.
let selection = null;
let csrfToken = '';
let selectionRevision = 0;
export const alphaClient = process.env.REACT_APP_ADENREL_PROFILE === 'alpha';
export const selectPlayerCharacter = value => { selection = value; selectionRevision++; };
export const playerSelectionKey = () => `${selectionRevision}:${selection?.worldId || ''}:${selection?.characterId || ''}`;
export const setPlayerCsrf = value => { csrfToken = value; };
export const playerHeaders = () => alphaClient ? { 'X-CSRF-Token': csrfToken } : {};
export const playerUrl = url => {
  if (!alphaClient) {
    if (selection?.local && selection?.pending) throw new Error('Your character’s world is still being prepared.');
    if (!selection?.local || !selection?.characterId) return url;
    const parsed = new URL(String(url), window.location.origin);
    return `${parsed.origin}/local/worlds/${encodeURIComponent(selection.characterId)}${parsed.pathname}${parsed.search}`;
  }
  const parsed = new URL(String(url), window.location.origin);
  if (window.location.pathname === '/admin') return `/api/admin${parsed.pathname}${parsed.search}`;
  if (selection?.pending) throw new Error('Your character’s world is still being prepared.');
  if (!selection?.characterId) throw new Error('Select a character before accessing a world.');
  return `/api/worlds/${encodeURIComponent(selection.characterId)}${parsed.pathname}${parsed.search}`;
};
export const configurePlayerXhr = (xhr, method, url) => {
  xhr.open(method, playerUrl(url), true);
  if (alphaClient) {
    xhr.withCredentials = true;
    for (const [key, value] of Object.entries(playerHeaders())) xhr.setRequestHeader(key, value);
  }
};
